import type { ApiService } from "@/domains/api/api-service"

import type { MinimalPoolApiData } from "./types"

export class MinimalPoolApiTransport {
  constructor(private apiService: ApiService) {}

  /**
   * Load all minimal pools from API
   * Pure data loading - no state, no caching, no side effects
   */
  async loadMinimalPools(): Promise<Array<MinimalPoolApiData>> {
    const response = await this.apiService.getAllMinimalRealTimePairs()
    return response as Array<MinimalPoolApiData>
  }
}
